module.exports = __webpack_public_path__ + "static/immagine7-606489f09fba8d54507cc38195568e0d.png";